/**
 * @flow
 * @relayHash dc703ff7ae8b6966206ad42955c08f20
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type HomeContent_currentTenant$ref = any;
export type ApplicabilityType = "LOCAL" | "LOCALIZED" | "SYSTEM" | "%future added value";
export type RevisionStatus = "NEW" | "REVISED" | "UNCHANGED" | "%future added value";
export type HomeContentQueryVariables = {||};
export type HomeContentQueryResponse = {|
  +pendingDocuments: ?{|
    +documents: ?{|
      +totalCount: ?number,
      +edges: $ReadOnlyArray<?{|
        +node: ?{|
          +id: string,
          +pk: ?number,
          +name: string,
          +bloc: {|
            +name: string
          |},
          +applicabilityType: ?ApplicabilityType,
          +category: {|
            +name: string
          |},
          +effectiveDate: ?string,
          +restricted: boolean,
          +legacyEffectiveDate: ?string,
          +isTemplate: ?boolean,
          +systemDocumentTemplate: ?{|
            +name: ?string
          |},
          +documentsOfTemplate: ?{|
            +documents: ?$ReadOnlyArray<?{|
              +pk: ?number,
              +name: string,
              +bloc: {|
                +pk: ?number,
                +name: string,
              |},
              +applicabilityType: ?ApplicabilityType,
              +category: {|
                +name: string
              |},
              +effectiveDate: ?string,
              +restricted: boolean,
              +legacyEffectiveDate: ?string,
            |}>
          |},
        |}
      |}>,
    |},
    +viewOnlyPks: ?$ReadOnlyArray<?number>,
  |},
  +documentsToReviewHome: ?{|
    +documents: ?$ReadOnlyArray<?{|
      +pk: ?number,
      +name: string,
      +bloc: {|
        +pk: ?number,
        +name: string,
      |},
      +applicabilityType: ?ApplicabilityType,
      +category: {|
        +name: string
      |},
      +expirationDate: ?string,
      +restricted: boolean,
      +isTemplate: ?boolean,
      +systemDocumentTemplate: ?{|
        +name: ?string
      |},
      +documentsOfTemplate: ?{|
        +documents: ?$ReadOnlyArray<?{|
          +pk: ?number,
          +name: string,
          +bloc: {|
            +pk: ?number,
            +name: string,
          |},
          +applicabilityType: ?ApplicabilityType,
          +category: {|
            +name: string
          |},
          +expirationDate: ?string,
        |}>
      |},
    |}>,
    +totalCount: ?number,
    +buckets: ?any,
    +counts: ?{|
      +templateCount: ?number,
      +templateRejectedCount: ?number,
    |},
  |},
  +myDocumentsToAcknowledge: ?{|
    +totalCount: ?number,
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +totalAcknowledged: ?number,
        +totalAssigned: ?number,
        +line: ?{|
          +pk: ?number,
          +document: ?{|
            +pk: ?number,
            +name: string,
            +hasAttachments: ?boolean,
            +effectiveDate: ?string,
            +legacyEffectiveDate: ?string,
            +restricted: boolean,
            +category: {|
              +name: string
            |},
            +bloc: {|
              +name: string
            |},
            +applicabilityType: ?ApplicabilityType,
          |},
        |},
      |}
    |}>,
  |},
  +recentlyRevisedDocuments: ?{|
    +documents: ?{|
      +totalCount: ?number,
      +edges: $ReadOnlyArray<?{|
        +node: ?{|
          +pk: ?number,
          +name: string,
          +bloc: {|
            +name: string
          |},
          +category: {|
            +name: string
          |},
          +applicabilityType: ?ApplicabilityType,
          +revisedFromParent: ?boolean,
          +effectiveDate: ?string,
          +legacyEffectiveDate: ?string,
          +restricted: boolean,
          +revisedFromParentStatus: ?RevisionStatus,
          +isTemplate: ?boolean,
          +systemDocumentTemplate: ?{|
            +name: ?string
          |},
          +documentsOfTemplate: ?{|
            +documents: ?$ReadOnlyArray<?{|
              +pk: ?number,
              +name: string,
              +bloc: {|
                +pk: ?number,
                +name: string,
              |},
              +applicabilityType: ?ApplicabilityType,
              +category: {|
                +name: string
              |},
              +effectiveDate: ?string,
              +revisedFromParentStatus: ?RevisionStatus,
            |}>
          |},
        |}
      |}>,
    |},
    +buckets: ?any,
  |},
  +currentTenant: ?{|
    +$fragmentRefs: HomeContent_currentTenant$ref
  |},
|};
export type HomeContentQuery = {|
  variables: HomeContentQueryVariables,
  response: HomeContentQueryResponse,
|};
*/


/*
query HomeContentQuery {
  pendingDocuments(showAll: false) {
    documents(first: 5) {
      totalCount
      edges {
        node {
          id
          pk
          name
          bloc {
            name
            id
          }
          applicabilityType
          category {
            name
            id
          }
          effectiveDate
          restricted
          legacyEffectiveDate
          isTemplate
          systemDocumentTemplate {
            name
            id
          }
          documentsOfTemplate {
            documents {
              pk
              name
              bloc {
                pk
                name
                id
              }
              applicabilityType
              category {
                name
                id
              }
              effectiveDate
              restricted
              legacyEffectiveDate
              id
            }
          }
        }
      }
    }
    viewOnlyPks
  }
  documentsToReviewHome {
    documents {
      pk
      name
      bloc {
        pk
        name
        id
      }
      applicabilityType
      category {
        name
        id
      }
      expirationDate
      restricted
      isTemplate
      systemDocumentTemplate {
        name
        id
      }
      documentsOfTemplate {
        documents {
          pk
          name
          bloc {
            pk
            name
            id
          }
          applicabilityType
          category {
            name
            id
          }
          expirationDate
          id
        }
      }
      id
    }
    totalCount
    buckets
    counts {
      templateCount
      templateRejectedCount
    }
  }
  myDocumentsToAcknowledge(first: 5) {
    totalCount
    edges {
      node {
        totalAcknowledged
        totalAssigned
        line {
          pk
          document {
            pk
            name
            hasAttachments
            effectiveDate
            legacyEffectiveDate
            restricted
            category {
              name
              id
            }
            bloc {
              name
              id
            }
            applicabilityType
            id
          }
          id
        }
      }
    }
  }
  recentlyRevisedDocuments {
    documents(first: 5) {
      totalCount
      edges {
        node {
          pk
          name
          bloc {
            name
            id
          }
          category {
            name
            id
          }
          applicabilityType
          revisedFromParent
          effectiveDate
          legacyEffectiveDate
          restricted
          revisedFromParentStatus
          isTemplate
          systemDocumentTemplate {
            name
            id
          }
          documentsOfTemplate {
            documents {
              pk
              name
              bloc {
                pk
                name
                id
              }
              applicabilityType
              category {
                name
                id
              }
              effectiveDate
              revisedFromParentStatus
              id
            }
          }
          id
        }
      }
    }
    buckets
  }
  currentTenant {
    ...HomeContent_currentTenant
    id
  }
}

fragment HomeContent_currentTenant on TenantType {
  settings {
    customWelcomeContentShow
    customWelcomeContentPsa
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "showAll",
    "value": false,
    "type": "Boolean"
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 5,
    "type": "Int"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "totalCount",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "pk",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v6 = [
  v5
],
v7 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "bloc",
  "storageKey": null,
  "args": null,
  "concreteType": "BlocType",
  "plural": false,
  "selections": v6
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "applicabilityType",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "category",
  "storageKey": null,
  "args": null,
  "concreteType": "CategoryType",
  "plural": false,
  "selections": v6
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "effectiveDate",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "restricted",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "legacyEffectiveDate",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isTemplate",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "systemDocumentTemplate",
  "storageKey": null,
  "args": null,
  "concreteType": "SystemDocumentTemplateType",
  "plural": false,
  "selections": v6
},
v15 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "bloc",
  "storageKey": null,
  "args": null,
  "concreteType": "BlocType",
  "plural": false,
  "selections": [
    v4,
    v5
  ]
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "viewOnlyPks",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "expirationDate",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "buckets",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "counts",
  "storageKey": null,
  "args": null,
  "concreteType": "DueForReviewCounts",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "templateCount",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "templateRejectedCount",
      "args": null,
      "storageKey": null
    }
  ]
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "totalAcknowledged",
  "args": null,
  "storageKey": null
},
v21 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "totalAssigned",
  "args": null,
  "storageKey": null
},
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasAttachments",
  "args": null,
  "storageKey": null
},
v23 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "revisedFromParent",
  "args": null,
  "storageKey": null
},
v24 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "revisedFromParentStatus",
  "args": null,
  "storageKey": null
},
v25 = [
  v5,
  v3
],
v26 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "bloc",
  "storageKey": null,
  "args": null,
  "concreteType": "BlocType",
  "plural": false,
  "selections": v25
},
v27 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "category",
  "storageKey": null,
  "args": null,
  "concreteType": "CategoryType",
  "plural": false,
  "selections": v25
},
v28 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "systemDocumentTemplate",
  "storageKey": null,
  "args": null,
  "concreteType": "SystemDocumentTemplateType",
  "plural": false,
  "selections": v25
},
v29 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "bloc",
  "storageKey": null,
  "args": null,
  "concreteType": "BlocType",
  "plural": false,
  "selections": [
    v4,
    v5,
    v3
  ]
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "HomeContentQuery",
  "id": "ff5c21e0a2840ae8c4c49d40a2030a8e",
  "text": null,
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "HomeContentQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "pendingDocuments",
        "storageKey": "pendingDocuments(showAll:false)",
        "args": v0,
        "concreteType": "PendingDocumentsReportType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "documents",
            "storageKey": "documents(first:5)",
            "args": v1,
            "concreteType": "DocumentCountableConnection",
            "plural": false,
            "selections": [
              v2,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "DocumentCountableEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "DocumentType",
                    "plural": false,
                    "selections": [
                      v3,
                      v4,
                      v5,
                      v7,
                      v8,
                      v9,
                      v10,
                      v11,
                      v12,
                      v13,
                      v14,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "documentsOfTemplate",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "DocumentsOfTemplateType",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "documents",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "DocumentType",
                            "plural": true,
                            "selections": [
                              v4,
                              v5,
                              v15,
                              v8,
                              v9,
                              v10,
                              v11,
                              v12
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          v16
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "documentsToReviewHome",
        "storageKey": null,
        "args": null,
        "concreteType": "DocumentsToReviewHomePageType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "documents",
            "storageKey": null,
            "args": null,
            "concreteType": "DocumentType",
            "plural": true,
            "selections": [
              v4,
              v5,
              v15,
              v8,
              v9,
              v17,
              v11,
              v13,
              v14,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "documentsOfTemplate",
                "storageKey": null,
                "args": null,
                "concreteType": "DocumentsOfTemplateType",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "documents",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "DocumentType",
                    "plural": true,
                    "selections": [
                      v4,
                      v5,
                      v15,
                      v8,
                      v9,
                      v17
                    ]
                  }
                ]
              }
            ]
          },
          v2,
          v18,
          v19
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "myDocumentsToAcknowledge",
        "storageKey": "myDocumentsToAcknowledge(first:5)",
        "args": v1,
        "concreteType": "CountableConnectionAcknowledgmentConnection",
        "plural": false,
        "selections": [
          v2,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "CountableConnectionAcknowledgmentEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "AcknowledgmentDocumentLineType",
                "plural": false,
                "selections": [
                  v20,
                  v21,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "line",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "DocumentLineType",
                    "plural": false,
                    "selections": [
                      v4,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "document",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "DocumentType",
                        "plural": false,
                        "selections": [
                          v4,
                          v5,
                          v22,
                          v10,
                          v12,
                          v11,
                          v9,
                          v7,
                          v8
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "recentlyRevisedDocuments",
        "storageKey": null,
        "args": null,
        "concreteType": "NewAndRecentlyRevisedType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "documents",
            "storageKey": "documents(first:5)",
            "args": v1,
            "concreteType": "DocumentCountableConnection",
            "plural": false,
            "selections": [
              v2,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "DocumentCountableEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "DocumentType",
                    "plural": false,
                    "selections": [
                      v4,
                      v5,
                      v7,
                      v9,
                      v8,
                      v23,
                      v10,
                      v12,
                      v11,
                      v24,
                      v13,
                      v14,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "documentsOfTemplate",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "DocumentsOfTemplateType",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "documents",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "DocumentType",
                            "plural": true,
                            "selections": [
                              v4,
                              v5,
                              v15,
                              v8,
                              v9,
                              v10,
                              v24
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          v18
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "currentTenant",
        "storageKey": null,
        "args": null,
        "concreteType": "TenantType",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "HomeContent_currentTenant",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "HomeContentQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "pendingDocuments",
        "storageKey": "pendingDocuments(showAll:false)",
        "args": v0,
        "concreteType": "PendingDocumentsReportType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "documents",
            "storageKey": "documents(first:5)",
            "args": v1,
            "concreteType": "DocumentCountableConnection",
            "plural": false,
            "selections": [
              v2,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "DocumentCountableEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "DocumentType",
                    "plural": false,
                    "selections": [
                      v3,
                      v4,
                      v5,
                      v26,
                      v8,
                      v27,
                      v10,
                      v11,
                      v12,
                      v13,
                      v28,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "documentsOfTemplate",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "DocumentsOfTemplateType",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "documents",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "DocumentType",
                            "plural": true,
                            "selections": [
                              v4,
                              v5,
                              v29,
                              v8,
                              v27,
                              v10,
                              v11,
                              v12,
                              v3
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          v16
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "documentsToReviewHome",
        "storageKey": null,
        "args": null,
        "concreteType": "DocumentsToReviewHomePageType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "documents",
            "storageKey": null,
            "args": null,
            "concreteType": "DocumentType",
            "plural": true,
            "selections": [
              v4,
              v5,
              v29,
              v8,
              v27,
              v17,
              v11,
              v13,
              v28,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "documentsOfTemplate",
                "storageKey": null,
                "args": null,
                "concreteType": "DocumentsOfTemplateType",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "documents",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "DocumentType",
                    "plural": true,
                    "selections": [
                      v4,
                      v5,
                      v29,
                      v8,
                      v27,
                      v17,
                      v3
                    ]
                  }
                ]
              },
              v3
            ]
          },
          v2,
          v18,
          v19
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "myDocumentsToAcknowledge",
        "storageKey": "myDocumentsToAcknowledge(first:5)",
        "args": v1,
        "concreteType": "CountableConnectionAcknowledgmentConnection",
        "plural": false,
        "selections": [
          v2,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "CountableConnectionAcknowledgmentEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "AcknowledgmentDocumentLineType",
                "plural": false,
                "selections": [
                  v20,
                  v21,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "line",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "DocumentLineType",
                    "plural": false,
                    "selections": [
                      v4,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "document",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "DocumentType",
                        "plural": false,
                        "selections": [
                          v4,
                          v5,
                          v22,
                          v10,
                          v12,
                          v11,
                          v27,
                          v26,
                          v8,
                          v3
                        ]
                      },
                      v3
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "recentlyRevisedDocuments",
        "storageKey": null,
        "args": null,
        "concreteType": "NewAndRecentlyRevisedType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "documents",
            "storageKey": "documents(first:5)",
            "args": v1,
            "concreteType": "DocumentCountableConnection",
            "plural": false,
            "selections": [
              v2,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "DocumentCountableEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "DocumentType",
                    "plural": false,
                    "selections": [
                      v4,
                      v5,
                      v26,
                      v27,
                      v8,
                      v23,
                      v10,
                      v12,
                      v11,
                      v24,
                      v13,
                      v28,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "documentsOfTemplate",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "DocumentsOfTemplateType",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "documents",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "DocumentType",
                            "plural": true,
                            "selections": [
                              v4,
                              v5,
                              v29,
                              v8,
                              v27,
                              v10,
                              v24,
                              v3
                            ]
                          }
                        ]
                      },
                      v3
                    ]
                  }
                ]
              }
            ]
          },
          v18
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "currentTenant",
        "storageKey": null,
        "args": null,
        "concreteType": "TenantType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "settings",
            "storageKey": null,
            "args": null,
            "concreteType": "TenantSettingsType",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "customWelcomeContentShow",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "customWelcomeContentPsa",
                "args": null,
                "storageKey": null
              },
              v3
            ]
          },
          v3
        ]
      }
    ]
  }
};
})();
node.text = "query HomeContentQuery {\n  pendingDocuments(showAll: false) {\n    documents(first: 5) {\n      totalCount\n      edges {\n        node {\n          id\n          pk\n          name\n          bloc {\n            name\n            id\n          }\n          applicabilityType\n          category {\n            name\n            id\n          }\n          effectiveDate\n          restricted\n          legacyEffectiveDate\n          isTemplate\n          systemDocumentTemplate {\n            name\n            id\n          }\n          documentsOfTemplate {\n            documents {\n              pk\n              name\n              bloc {\n                pk\n                name\n                id\n              }\n              applicabilityType\n              category {\n                name\n                id\n              }\n              effectiveDate\n              restricted\n              legacyEffectiveDate\n              id\n            }\n          }\n        }\n      }\n    }\n    viewOnlyPks\n  }\n  documentsToReviewHome {\n    documents {\n      pk\n      name\n      bloc {\n        pk\n        name\n        id\n      }\n      applicabilityType\n      category {\n        name\n        id\n      }\n      expirationDate\n      restricted\n      isTemplate\n      systemDocumentTemplate {\n        name\n        id\n      }\n      documentsOfTemplate {\n        documents {\n          pk\n          name\n          bloc {\n            pk\n            name\n            id\n          }\n          applicabilityType\n          category {\n            name\n            id\n          }\n          expirationDate\n          id\n        }\n      }\n      id\n    }\n    totalCount\n    buckets\n    counts {\n      templateCount\n      templateRejectedCount\n    }\n  }\n  myDocumentsToAcknowledge(first: 5) {\n    totalCount\n    edges {\n      node {\n        totalAcknowledged\n        totalAssigned\n        line {\n          pk\n          document {\n            pk\n            name\n            hasAttachments\n            effectiveDate\n            legacyEffectiveDate\n            restricted\n            category {\n              name\n              id\n            }\n            bloc {\n              name\n              id\n            }\n            applicabilityType\n            id\n          }\n          id\n        }\n      }\n    }\n  }\n  recentlyRevisedDocuments {\n    documents(first: 5) {\n      totalCount\n      edges {\n        node {\n          pk\n          name\n          bloc {\n            name\n            id\n          }\n          category {\n            name\n            id\n          }\n          applicabilityType\n          revisedFromParent\n          effectiveDate\n          legacyEffectiveDate\n          restricted\n          revisedFromParentStatus\n          isTemplate\n          systemDocumentTemplate {\n            name\n            id\n          }\n          documentsOfTemplate {\n            documents {\n              pk\n              name\n              bloc {\n                pk\n                name\n                id\n              }\n              applicabilityType\n              category {\n                name\n                id\n              }\n              effectiveDate\n              revisedFromParentStatus\n              id\n            }\n          }\n          id\n        }\n      }\n    }\n    buckets\n  }\n  currentTenant {\n    ...HomeContent_currentTenant\n    id\n  }\n}\n\nfragment HomeContent_currentTenant on TenantType {\n  settings {\n    customWelcomeContentShow\n    customWelcomeContentPsa\n    id\n  }\n}\n";
(node/*: any*/).hash = '755757d6000f93bffbebf57cd567e35d';
module.exports = node;
